import { useAuth } from "@/contexts/AuthContext";

export const useAuthState = () => {
  const { user } = useAuth();
  return { user };
};